const theme = {
	colors: {
		navbarBgColor: "#e1f1dd",
		mainColor: "#00adb5",
		logoColor: "#393e46",
		linkColor: "#02475e",
	},
	screens: {
		lg: "900px",
	},
};
export default theme;
